'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Dropdown = require('../Dropdown/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _DropdownSource = require('../Dropdown/DropdownSource');

var _DropdownSource2 = _interopRequireDefault(_DropdownSource);

var _DropdownTarget = require('../Dropdown/DropdownTarget');

var _DropdownTarget2 = _interopRequireDefault(_DropdownTarget);

var _DatePickerContext = require('./DatePickerContext');

var _DatePickerContext2 = _interopRequireDefault(_DatePickerContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatePicker = function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker() {
    _classCallCheck(this, DatePicker);

    return _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
  }

  _createClass(DatePicker, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['children']);

      return _react2.default.createElement(
        _Dropdown2.default,
        { showArrow: true },
        _react2.default.createElement(
          _DropdownTarget2.default,
          null,
          children
        ),
        _react2.default.createElement(
          _DropdownSource2.default,
          { maxHeight: 'auto', width: 'auto' },
          _react2.default.createElement(_DatePickerContext2.default, rest)
        )
      );
    }
  }]);

  return DatePicker;
}(_react.Component);

DatePicker.propTypes = {
  /**
   * The date that should be shown to the user when the picker opens.
   * When a selected date or range is given, that supersedes this
   * property. Defaults to 'today'.
   */
  calendarOpenDate: _propTypes2.default.instanceOf(Date),
  /** The element to position the DatePicker around */
  children: _propTypes2.default.node.isRequired,
  /** A lower limit to the earliest date that can be selected */
  earliestSelectableDate: _propTypes2.default.instanceOf(Date),
  /** An upper limit to the latest date that can be selected */
  latestSelectableDate: _propTypes2.default.instanceOf(Date),
  /** Callback for when the apply button has been clicked */
  onApply: _propTypes2.default.func,
  /** Callback for when the cancel button has been clicked */
  onCancel: _propTypes2.default.func,
  /** Callback for when a date, range with endDate and startDate, or a range
   * out of rangeSelections has been selected */
  onSelect: _propTypes2.default.func.isRequired,
  /** Whether a date range can be selected */
  rangeSelect: _propTypes2.default.bool,
  /** Predefined date ranges offered for selection. label will be shown and
   * range is passed to onSelect when clicked. */
  rangeSelections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    range: _propTypes2.default.string.isRequired
  })),
  /** A single date that appears selected */
  selectedDate: _propTypes2.default.instanceOf(Date),
  /** The date selected at the end of the range */
  selectedEndDate: _propTypes2.default.instanceOf(Date),
  /** The selected range, specified as it's label */
  selectedRange: _propTypes2.default.string,
  /** The date selected at the start of the range */
  selectedStartDate: _propTypes2.default.instanceOf(Date),
  /** Configuration for a single date picker view or two pickers side by side */
  view: _propTypes2.default.oneOf(['single', 'double'])
};
DatePicker.defaultProps = {
  view: 'single',
  rangeSelect: false
};
exports.default = DatePicker;